/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const OnlinePaymentsImages = require('./images');
const Head = require('./components/Head');
const CustomCard = require('./components/CustomCard');
const DevProgramBanner = require('./components/DevProgramBanner');

const mobileCheckoutBlockedSites = ['MCO'];

function OnlinePayments(props) {
  const { i18n, lang, platform, deviceType, setActiveItem, assetsPath } = props;

  const { OnlinePaymentsCheckoutPro, OnlinePaymentsCheckoutAPI, OnlinePaymentsPaymentLink } = OnlinePaymentsImages;
  return (
    <div className="online-payments-container">
      <Head i18n={i18n} deviceType={deviceType} />
      <div className="online-payments-main-cards">
        <CustomCard
          lang={lang}
          cardLink={`/developers/${lang}/guides/online-payments/checkout-pro/introduction`}
          trackClickData="OP_LANDING_CHOPRO"
          setActiveItem={setActiveItem}
          siteId={platform.siteId}
          cardImage={<OnlinePaymentsCheckoutPro />}
          cardTitle={i18n.gettext('Checkout Pro')}
          cardText={i18n.gettext('Procesa pagos de forma segura y simple con un diseño y un front end listos para usar y aumentar la conversión')}
        />
        <CustomCard
          lang={lang}
          cardLink={`/developers/${lang}/guides/online-payments/checkout-api/landing`}
          trackClickData="OP_LANDING_CHOAPI"
          setActiveItem={setActiveItem}
          siteId={platform.siteId}
          cardImage={<OnlinePaymentsCheckoutAPI />}
          cardTitle={i18n.gettext('Checkout API')}
          cardText={`${i18n.gettext('Una solución versátil para que construyas tu propio procesador de pagos')}. ${i18n.gettext('Desde configuraciones básicas a avanzadas, tú controlas la experiencia')}.`}
        />
        <CustomCard
          lang={lang}
          cardLink={`/developers/${lang}/guides/online-payments/payment-link/create-button`}
          trackClickData="OP_LANDING_LINK"
          setActiveItem={setActiveItem}
          siteId={platform.siteId}
          cardImage={<OnlinePaymentsPaymentLink />}
          cardTitle={i18n.gettext('Link de pago')}
          cardText={`${i18n.gettext('Crea un link de pago en pocos pasos y úsalo al instante para cobrar por chat y redes sociales')}. ${i18n.gettext('No necesitas conocimientos técnicos')}.`}
        />
      </div>

      <div className="online-payments-title">
        <div className="online-payments-title__text">
          <h3>{i18n.gettext('Otras maneras de procesar cobros online')}</h3>
        </div>
      </div>

      <div className="online-payments-secondary-cards">
        {!mobileCheckoutBlockedSites.includes(platform?.siteId?.toUpperCase())
          && <CustomCard
            lang={lang}
            cardLink={`/developers/${lang}/guides/online-payments/mobile-checkout/introduction`}
            trackClickData="OP_LANDING_MOBILECHO"
            setActiveItem={setActiveItem}
            siteId={platform.siteId}
            cardTitle={i18n.gettext('Mobile Checkout')}
            cardText={`${i18n.gettext('Procesa pagos en aplicaciones nativas con el Checkout de Mercado Pago embebido')}. ${i18n.gettext('Listo para implementar en sistemas operativos Android y iOS')}`}
          />}

        <CustomCard
          lang={lang}
          cardLink={`/developers/${lang}/guides/online-payments/subscriptions/introduction`}
          trackClickData="OP_LANDING_SUBSCRIPTIONS"
          setActiveItem={setActiveItem}
          siteId={platform.siteId}
          cardTitle={i18n.gettext('Suscripciones')}
          cardText={`${i18n.gettext('Recibe pagos de forma recurrente con Mercado Pago')}. ${i18n.gettext('Define los ciclos y tiempos de activación que necesites')}`}
        />
      </div>
      <DevProgramBanner i18n={i18n} assetsPath={assetsPath} lang={lang} />

    </div>
  );
}

OnlinePayments.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  platform: PropTypes.shape({
    domain: PropTypes.string,
  }).isRequired,
  deviceType: PropTypes.string.isRequired,
  assetsPath: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
};

OnlinePayments.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = OnlinePayments;
